module.exports = __webpack_public_path__ + "media/images/arrows/twisted/orange-right2-b6895406e949786175bbd630e81b4fdc.svg";